import { API } from "aws-amplify";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";

export const GET_NETWORK_DOWNLOAD_TEMPLATE_REQUEST =
  "@@network/GET_NETWORK_DOWNLOAD_TEMPLATE_REQUEST";
export const GET_NETWORK_DOWNLOAD_TEMPLATE_SUCCESS =
  "@@network/GET_NETWORK_DOWNLOAD_TEMPLATE_SUCCESS";
export const GET_NETWORK_DOWNLOAD_TEMPLATE_FAILURE =
  "@@network/GET_NETWORK_DOWNLOAD_TEMPLATE_FAILURE";

export function getNetworkDownloadTemplate(
  id = "",
  organisation,
  sample_table = true
) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_NETWORK_DOWNLOAD_TEMPLATE_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_networks&organisation=${organisation}&sample_table=${sample_table}`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_NETWORK_DOWNLOAD_TEMPLATE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_NETWORK_DOWNLOAD_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_NETWORK_LIST_REQUEST = "@@network/GET_NETWORK_LIST_REQUEST";
export const GET_NETWORK_LIST_SUCCESS = "@@network/GET_NETWORK_LIST_SUCCESS";
export const GET_NETWORK_LIST_FAILURE = "@@network/GET_NETWORK_LIST_FAILURE";

export function getNetworkList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_NETWORK_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_networks&organisation=${organisation}&sample_table=false`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_NETWORK_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_NETWORK_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const DELETE_NETWORK_LIST_REQUEST =
  "@@network/DELETE_NETWORK_LIST_REQUEST";
export const DELETE_NETWORK_LIST_SUCCESS =
  "@@network/DELETE_NETWORK_LIST_SUCCESS";
export const DELETE_NETWORK_LIST_FAILURE =
  "@@network/DELETE_NETWORK_LIST_FAILURE";

export function deleteNetworkList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: DELETE_NETWORK_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=in_networks&organisation=${organisation}`;
      }

      const response = await API.del("usimAPI", url);
      dispatch({
        type: DELETE_NETWORK_LIST_SUCCESS,
        payload: response,
      });
      dispatch(getNetworkList(id, organisation));
    } catch (error) {
      dispatch({
        type: DELETE_NETWORK_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const UPLOAD_NETWORK_DATA_REQUEST =
  "@@network/UPLOAD_NETWORK_DATA_REQUEST";
export const UPLOAD_NETWORK_DATA_SUCCESS =
  "@@network/UPLOAD_NETWORK_DATA_SUCCESS";
export const UPLOAD_NETWORK_DATA_FAILURE =
  "@@network/UPLOAD_NETWORK_DATA_FAILURE";

export function uploadNetworkData(
  id = "",
  organisation,
  file,
  columnMappings,
  callback
) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: UPLOAD_NETWORK_DATA_REQUEST,
    });
    try {
      let url = "/presignedurl";
      if (id) {
        url = `${url}?project_id=${id}&table_name=in_networks`;
      }

      if (!isEmpty(columnMappings)) {
        url = `${url}&column_mappings=${encodeURI(
          JSON.stringify(columnMappings)
        )}`;
      }

      const response = await API.get("usimAPI", url);

      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": file.type },
        body: file,
      };
      await fetch(response.uploadURL, requestOptions).then((response) => {
        if (response.status === 200) {
          toast.success("Data uploaded successfully!");
          setTimeout(() => {
            dispatch(getNetworkList(id, organisation));
          }, 2000);
          callback({
            success: true,
          });
        } else {
          dispatch({
            type: UPLOAD_NETWORK_DATA_FAILURE,
            payload: {
              message: "Upload data failed.",
            },
          });
        }
      });

      dispatch({
        type: UPLOAD_NETWORK_DATA_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: UPLOAD_NETWORK_DATA_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}
